<template>
  <el-sub-menu v-if="hasChildren" :index="itemIndex" class="el-sub-menu-l">
    <template #title>
      <div
        class="role-menu-title"
        :class="{ 'is-disabled': role.isLoginIn }"
        @click.stop="handleClick"
      >
      <img class="role-logo" v-if="role.logoPath" :src="role.logoPath" alt="logo" />
      <el-icon class="role-icon" v-else><User /></el-icon>
        <span class="role-text">
          {{role.adminName}}({{ role.roleName }})
        </span>
        <el-tag type="info" v-if="role.adminState==2">离职</el-tag>
        <span v-if="role.isLoginIn" class="current-role-tag">当前</span>
      </div>
    </template>

    <RoleMenuItem
      v-for="child in children"
      :key="childKey(child)"
      :role="child"
      :navigate="navigate"
      :parent-index="itemIndex"
    />
  </el-sub-menu>

  <el-menu-item v-else :index="itemIndex" :disabled="role.isLoginIn" @click="handleClick" class="el-sub-menu-l">
    <div class="role-menu-item">
      <img class="role-logo" v-if="role.logoPath" :src="role.logoPath" alt="logo" />
      <el-icon class="role-icon" v-else><User /></el-icon>
      <span class="role-text">
        {{role.adminName}}({{ role.roleName }})
      </span>
       <el-tag type="info" v-if="role.adminState==2">离职</el-tag>
      <span v-if="role.isLoginIn" class="current-role-tag">当前</span>
    </div>
  </el-menu-item>
</template>

<script>
export default {
  name: "RoleMenuItem",
  props: {
    role: { type: Object, required: true },
    navigate: { type: Function, required: true },
    parentIndex: { type: String, default: "" },
  },
  computed: {
    children() {
      return this.role.childs || this.role.children || [];
    },
    hasChildren() {
      return Array.isArray(this.children) && this.children.length > 0;
    },
    nodeId() {
      const roleId = this.role?.roleId;
      const adminId = this.role?.adminId;
      if (roleId != null && adminId != null) return `${roleId}-${adminId}`;
      if (roleId != null) return String(roleId);
      if (adminId != null) return String(adminId);
      if (this.role?.pcSiteUrl) return String(this.role.pcSiteUrl);
      return `${this.role?.roleName || ""}-${this.role?.adminName || ""}`;
    },
    itemIndex() {
      // Element Plus 的 submenu 展开状态用 index 作为 key；index 重复会导致“点一个展开多个”。
      return this.parentIndex ? `${this.parentIndex}/${this.nodeId}` : this.nodeId;
    },
  },
  methods: {
    childKey(child) {
      const childRoleId = child?.roleId;
      const childAdminId = child?.adminId;
      const childId =
        childRoleId != null && childAdminId != null
          ? `${childRoleId}-${childAdminId}`
          : childRoleId != null
          ? String(childRoleId)
          : childAdminId != null
          ? String(childAdminId)
          : child?.pcSiteUrl
          ? String(child.pcSiteUrl)
          : `${child?.roleName || ""}-${child?.adminName || ""}`;
      return `${this.itemIndex}/${childId}`;
    },
    handleClick(e) {
      e?.stopPropagation?.();
      if (!this.role.isLoginIn) {
        this.navigate(this.role.pcSiteUrl, this.role);
      }
    },
  },
};
</script>

<style scoped>
.role-menu-title,
.role-menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 6px;
}

.role-menu-title {
  cursor: pointer;
}

.role-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.role-icon {
  margin-right: 2px;
}
.role-logo{
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}
.is-disabled {
  color: var(--el-text-color-disabled);
  cursor: not-allowed;
}
.el-sub-menu-l{
    border-bottom: 1px solid #ebeef5;
}
</style>
